var React = require('react');

function IconProfile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 12.9998C17.309 12.9998 20 15.6908 20 18.9998C20 19.5528 19.553 19.9998 19 19.9998C18.447 19.9998 18 19.5528 18 18.9998C18 16.7938 16.206 14.9998 14 14.9998H6C3.794 14.9998 2 16.7938 2 18.9998C2 19.5528 1.553 19.9998 1 19.9998C0.447 19.9998 0 19.5528 0 18.9998C0 15.6908 2.691 12.9998 6 12.9998H14ZM10 -0.000244141C13.313 -0.000244141 16 2.68676 16 5.99976C16 9.31276 13.313 11.9998 10 11.9998C6.687 11.9998 4 9.31276 4 5.99976C4 2.68676 6.687 -0.000244141 10 -0.000244141ZM10 1.99976C7.794 1.99976 6 3.79476 6 5.99976C6 8.20576 7.794 9.99976 10 9.99976C12.206 9.99976 14 8.20576 14 5.99976C14 3.79476 12.206 1.99976 10 1.99976Z","fill":"#0061EE"}));
}

IconProfile.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IconProfile;

IconProfile.default = IconProfile;
